export default "__VITE_ASSET__CtF6xan8__"